import wxsdk from "@/utils/wxsdk";
import global_ from "../../global.config";

export default {
  setFoundShareInviteClientPage(
    title,
    desc,
    pageInfo,
    shareSpreadInfo,
    isNotInitWxsdk,
    queryStr,
    shareImg,
    pathname,
    agentId,
    agentTel
  ) {
    global_.SHARE_TITLE = pageInfo.BrowserTabTitle;
    if (pageInfo.WxShare && pageInfo.WxShare.Title) {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.Description) {
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    if (shareImg) {
      global_.SHARE_IMG_URL = shareImg;
    } else if (pageInfo.WxShare && pageInfo.WxShare.FilePath) {
      global_.SHARE_IMG_URL = pageInfo.WxShare.FilePath;
    }
    if (title) {
      global_.SHARE_TITLE = title;
    }
    if (desc) {
      global_.SHARE_DESC = desc;
    }
    let shareLink = `${location.protocol}//${location.host}/h5/${pathname}`;
    shareLink += `?id=${shareSpreadInfo.id}&psn=${shareSpreadInfo.psn}&share=true&agentId=${agentId}&agentTel=${agentTel}`;
    shareLink += `&refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    if (queryStr) {
      shareLink += queryStr;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setFoundShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: shareLink
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  }
};
